/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import CloseIcon from '@material-ui/icons/Close';
import { formatNumber, GetGroupBy, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvLegendLabels, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartStatTiles } from '../ChartStatTiles';
import { ChartLimitNote } from '../ChartLimitNote';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartNotes } from '../ChartNotes';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px',
            '& .title': {
                fontSize: 16,
            },
            '& .colWrapper': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 15,
                flexFlow: 'row wrap',
            },
            '& .col': {
                fontSize: '16px',
                fontWeight: 600,
                textAlign: 'center',
                border: '1px solid',
                padding: '15px',
                display: 'flex',
                margin: '0 10px 10px 10px',
                flexFlow: 'column',
                flex: 1,
                '& .value': {
                    fontSize: '36px',
                    padding: '20px 0',
                },
                '& .sub': {
                    display: 'flex',
                    flexFlow: 'row wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                '& .status': {
                    marginLeft: '10px',
                    display: 'flex',
                    flexFlow: 'row wrap',
                    alignItems: 'center',
                },
            },
            '& .increase': {
                color: 'green',
            },
            '& .decrease': {
                color: 'red',
            },
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative'
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        footer: {
            fontSize: '1rem',
            textAlign: 'center',
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        cursorSpan: {
            cursor: 'pointer'
        }
    }),
);
interface BilledVsEstimatesChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    groupBy: string;
}
interface BilledVsEstimatesData {
    statistics: Statistics;
}
export interface Statistics {
    matter: Matter;
}
export interface Matter {
    billedFeesVsEstimates: BilledVsEstimates;
}
export interface BilledVsEstimates {
    billedFeeVsEstimate: BilledVsEstimate[];
    groupedByCount: number;
    matterBilledFeeAndEstimate: MatterBilledAndEstimate;
}

export interface BilledVsEstimate {
    totalFeesBilled: number;
    totalEstimatedCosts: number;
    groupedBy: string;
}

export interface MatterBilledAndEstimate {
    billedFee: number;
    estimate: number;
    mattersCount: number;
    mattersWithNoEstimate: number;
    mattersWithNoEstimateBilledFees: number;
}

interface ChartState {
    billedFees: number[];
    estimatedCosts: number[];
    groupedBy: string[];
    matterCount: number;
    matterWithNoEstimate: number;
    matterWithNoEstimateBilledFees: number;
    totalCount: number;
    percentage: number;
    symbol: string;
}
export const BilledVsEstimateGroupedChart: React.FC<BilledVsEstimatesChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const { loading, error, data } = useQuery<BilledVsEstimatesData>(BILLED_VS_ESTIMATE_QUERY, {
        variables: {
            groupBy: props.groupBy,
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords,
        },
    });

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0,
    })[1];

    const [state, setState] = useState<ChartState>({
        billedFees: [],
        estimatedCosts: [],
        groupedBy: [],
        matterCount: 0,
        matterWithNoEstimate: 0,
        matterWithNoEstimateBilledFees: 0,
        totalCount: 0,
        percentage: 0,
        symbol: '$',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }
    // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
    // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    useEffect(() => {
        if (!loading) {
            setState((prevState) => {
                let billedFees: number[] = [];
                let estimatedCosts: number[] = [];
                let groupedBy: string[] = [];
                let matterCount: number = 0;
                let matterWithNoEstimate: number = 0;
                let matterWithNoEstimateBilledFees: number = 0;
                let totalCount: number = 0;
                let percentage: number = 0;

                if (!error && data && data.statistics && data.statistics.matter && data.statistics.matter.billedFeesVsEstimates) {
                    billedFees = data.statistics.matter.billedFeesVsEstimates.billedFeeVsEstimate.map((o: BilledVsEstimate) => {
                        return o.totalFeesBilled;
                    });
                    estimatedCosts = data.statistics.matter.billedFeesVsEstimates.billedFeeVsEstimate.map((o: BilledVsEstimate) => {
                        return o.totalEstimatedCosts;
                    });
                    groupedBy = data.statistics.matter.billedFeesVsEstimates.billedFeeVsEstimate.map((o: BilledVsEstimate) => {
                        return o.groupedBy;
                    });

                    let totalBilledFee = data.statistics.matter.billedFeesVsEstimates.matterBilledFeeAndEstimate.billedFee;
                    let totalEstimate = data.statistics.matter.billedFeesVsEstimates.matterBilledFeeAndEstimate.estimate;
                    percentage = Math.round((totalBilledFee / totalEstimate) * 100);

                    matterCount = data.statistics.matter.billedFeesVsEstimates.matterBilledFeeAndEstimate.mattersCount;
                    matterWithNoEstimate = data.statistics.matter.billedFeesVsEstimates.matterBilledFeeAndEstimate.mattersWithNoEstimate;
                    matterWithNoEstimateBilledFees = data.statistics.matter.billedFeesVsEstimates.matterBilledFeeAndEstimate.mattersWithNoEstimateBilledFees;
                    totalCount = data.statistics.matter.billedFeesVsEstimates.groupedByCount;
                }

                return {
                    ...prevState,
                    billedFees,
                    estimatedCosts,
                    groupedBy,
                    percentage,
                    matterCount,
                    matterWithNoEstimate,
                    matterWithNoEstimateBilledFees,
                    totalCount,
                };
            });
        }
    // tslint:disable-next-line: align
    }, [loading, error, data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart('isBilledFeesVsEstimateByMatterTypeChartOpen');
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize();
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {
        const labels = state.groupedBy;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {
        const labels = state.groupedBy;
        // up
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const onZoom = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Billed vs Estimates by ' + GetGroupBy(props.groupBy)));
            // tslint:disable-next-line: align
        }, 500);
    };

    const handleTotalClick = (isPercentage: boolean) => () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            if (isPercentage) {
                searchCriterias.push(
                    { property: 'EstimatedCosts', operator: 'gt', comparison: '0' /*, combination: ' OR '*/ },
                    // { property: 'FeesBilledWithEstimates', operator: 'gt', comparison: '0' }
                );
            } else {
                searchCriterias.push({ property: 'EstimatedCosts', operator: 'gt', comparison: '0' });
            }

            props.getSelectedItem(searchCriterias, false, `Estimate vs Billed Fees By ${GetGroupBy(props.groupBy)}`, DrillDownType.matterSummaryDrilldown, 'Matters');
        }
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    if (loading || currencySymbolQuery.loading) {
        return (
            <div className="rv-chart rv-chart-loading">
                {chartControllerComponent()}
                <ChartSkeleton variant="bars" />
            </div>
        );
    }

    function handleNoEstimates() {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push({ property: 'EstimatedCosts', operator: 'eq', comparison: '0' });

            props.getSelectedItem(searchCriterias, false, 'Estimate vs Billed Fees', DrillDownType.matterSummaryDrilldown, 'Matters');
        }
    }
    
    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.estimatedCosts, state.billedFees) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<AssessmentOutlinedIcon />} title="Estimate vs Billed Fees" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick(true)}>
                    <AnimatedNumber value={state.percentage} format={(amount) => formatNumber(amount)} />%
                </div>
                <div className={classes.title} onClick={handleTotalClick(false)}>
                    <span className={classes.cursorSpan}>{formatNumber(state.matterCount)}</span> Current Matters with Estimates
                </div>
                <div className={classes.title}>Estimate vs Billed Fees By {GetGroupBy(props.groupBy)}</div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton size="medium" onClick={onScollBar('up')} ref={scrollUpAndPrevRef}>
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton size="medium" onClick={onScollBar('down')} ref={scrollDownAndNextRef}>
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const item = state.groupedBy[_index];

                            const searchCriterias = new Array<SearchCriteria>();

                            searchCriterias.push({ property: props.groupBy, operator: 'eq', comparison: item }, { property: 'EstimatedCosts', operator: 'gt', comparison: '0' });

                            props.getSelectedItem(
                                searchCriterias,
                                false,
                                `Estimate vs Billed Fees By ${GetGroupBy(props.groupBy)}`,
                                DrillDownType.matterSummaryDrilldown,
                                'Matters',
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.groupedBy),
                        datasets: [
                            {
                                label: 'Estimate',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: state.estimatedCosts,
                            },
                            {
                                label: 'Fees',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.amber),
                                data: state.billedFees,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick([...state.estimatedCosts, ...state.billedFees]),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit([...state.estimatedCosts, ...state.billedFees]),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${state.symbol}${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                min: 0,
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: true,
                                labels: rvLegendLabels,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: (context: any) => {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            //   dataset
                                        } = context;

                                        return `${state.symbol}${formattedValue}`;
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.estimatedCosts, state.billedFees) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <ChartStatTiles
                caption="Matters with no estimate"
                tiles={[
                    { label: 'Matters', value: formatNumber(state.matterWithNoEstimate), color: RV_CHART_COLORS.amber, onClick: () => handleNoEstimates() },
                    { label: 'Billed fees', value: `${state.symbol}${formatNumber(state.matterWithNoEstimateBilledFees)}`, color: RV_CHART_COLORS.green },
                ]}
            />
            <ChartNotes notes={['Fees only, disbursements are not included']} />
            {state.totalCount > 10 && !props.showAllRecords && <ChartLimitNote>The top 10 {GetGroupBy(props.groupBy)} are shown</ChartLimitNote>}
        </div>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

const BILLED_VS_ESTIMATE_QUERY = gql`
    query BilledFeesVsEstimates($groupBy: MatterGroupBy, $entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean) {
        statistics {
            matter {
                billedFeesVsEstimates(groupBy: $groupBy, entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords) {
                    groupedByCount
                    billedFeeVsEstimate {
                        totalFeesBilled
                        totalEstimatedCosts
                        groupedBy
                    }
                    matterBilledFeeAndEstimate {
                        mattersCount
                        mattersWithNoEstimate
                        mattersWithNoEstimateBilledFees
                        billedFee
                        estimate
                    }
                }
            }
        }
    }
`;
